import React, { ReactNode, useEffect, useState } from "react";
import useCurrentUser from "../../hooks/useCurrentUser";
import { ITask } from "../../data_models/task";
import { FilledButton } from "../common/Button";
import useRouting from "../../hooks/useRouting";
import useTasks from "../../hooks/useTasks";
import { set } from "react-datepicker/dist/date_utils";
import useConfig from "../../hooks/useConfig";
import { Chip } from "../common/Chip";
import BriefTaskComponent from "../common/tasks/BriefTaskComponent";


const FreelancerJobSuggestions = () => {

    const [tasks, setTasks] = useState<ITask[]>([]);

    const { fetchAllAvailableTasksAsFreelancer } = useTasks();

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const fetchTasks = async () => {
        const tasks = await fetchAllAvailableTasksAsFreelancer(page, limit);
        setTasks(tasks);
    }


    return (
        <div className="">
            <p className="body2">Jobs you might like</p>

            {/* No data available  */}
            {tasks.length === 0 && <div className="mt-4 flex flex-col items-center space-y-4">
                <img
                    src="https://storage.googleapis.com/public-platform-assets/images/no_data.svg"
                    alt="No Data"
                    className="w-2/3"
                />
                <p className="body1">Why don't you come back later</p>

            </div>}
            {/* List of tasks */}
            {tasks.length > 0 &&
                <div className="">
                    
                    {tasks.map((task) => (
                        <BriefTaskComponent task={task} />
                    ))}

                </div >
            }
        </div >
    );
};





export default FreelancerJobSuggestions;